var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.476 0C10.0583 0 9.64063 0.431874 8.79327 1.28954L3.74519 6.42336C2.81671 7.36618 3.1262 7.54258 4.10577 7.54258H6.65385V13.7713C6.65385 15.0608 7.6875 16.1071 8.96154 16.1071H12.0385C13.3125 16.1071 14.3462 15.0608 14.3462 13.7713V7.54258H16.8462C17.9309 7.54258 18.1593 7.36618 17.2308 6.42336L12.1587 1.28954C11.3113 0.431874 10.8936 0 10.476 0ZM0.5 14.5499V17.6642C0.5 18.9538 1.53365 20 2.80769 20H18.1923C19.4663 20 20.5 18.9538 20.5 17.6642V14.5499H18.9615V17.6642C18.9615 18.0931 18.616 18.4428 18.1923 18.4428H2.80769C2.38401 18.4428 2.03846 18.0931 2.03846 17.6642V14.5499H0.5Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.320d3d5cdaff65c595343d250fa29553.svg";
export { ForwardRef as ReactComponent };